export const rAccent = /[\u0300-\u036f]/g;
